"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var echarts = require('echarts/lib/echarts');

require('echarts/lib/chart/line');

require('echarts/lib/chart/radar');

require('echarts/lib/chart/bar');

require('echarts/lib/component/legend');

require('echarts/lib/component/tooltip');

require('echarts/lib/component/title'); // require("echarts/theme/macarons");


var _default = echarts;
exports.default = _default;